/** Object containing copilot actions along with their metadata. */
export const copilotActions = {
    translate: {
        title: 'Translate',
        icon: 'translate',
        commandName: 'richTextEditor:translate',
    },
    checkSpellingAndGrammar: {
        title: 'Check spelling and grammar',
        commandName: 'richTextEditor:checkSpellingAndGrammar',
        icon: 'url-trigger',
    },
    sendFeedback: {
        title: 'Send feedback',
        icon: 'paper-plane',
        hasDividerBefore: true,
    },
};
